import { graphql, HttpResponse } from 'msw'
import { type EnrollmentLoadingData, type EnrollmentLoadingSubmitOutput } from '../../../models'

export const getEnrollmentLoadingDataMock: EnrollmentLoadingData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/investments/loading',
}

export const submitEnrollmentLoadingDataMock: EnrollmentLoadingSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/investments/risk-return',
}

export const mockGetEnrollmentLoadingData = graphql.mutation('getEnrollmentLoadingData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentLoadingDataMock } })
})

export const mockSubmitEnrollmentLoadingData = graphql.mutation('submitEnrollmentLoadingData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentLoadingDataMock } })
})

export const mockEnrollmentLoading = [mockGetEnrollmentLoadingData, mockSubmitEnrollmentLoadingData]
